import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import { FC } from 'react';

import { useConfigContext } from '../../context/ConfigContext';
import DesktopList from './DesktopList';

const SX_MENU: SxProps<Theme> = {
  display: { lg: 'flex', xs: 'none' },
  flexGrow: 1,
  justifyContent: 'space-between',
};

const SX_SUBMENU: SxProps<Theme> = {
  flexGrow: 1,
};

const SX_SUBMENU_RIGHT: SxProps<Theme> = {
  ...SX_SUBMENU,
  textAlign: 'right',
};

const SX_ROUTE: SxProps<Theme> = {
  color: '#fff',
  fontSize: '.75rem',
  fontWeight: '600',
  letterSpacing: '2px',
  lineHeight: '1rem',
  textShadow: '0 0 4px var(--nav-shadow), 0 0 4px var(--nav-shadow)',
  textTransform: 'uppercase',
};

const SX_ROUTE_LEFT: SxProps<Theme> = {
  ...SX_ROUTE,
  marginRight: '1.75rem',
};

const SX_ROUTE_RIGHT: SxProps<Theme> = {
  ...SX_ROUTE,
  marginLeft: '1.75rem',
};

const DesktopMenu: FC = () => {
  const { menu } = useConfigContext();

  const items = menu.filter(item => item.showDesktop !== false);
  const countLeft = Math.ceil(items.length / 2);
  const left = items.slice(0, countLeft);
  const right = items.slice(countLeft);

  return (
    <Box sx={SX_MENU}>
      <Box sx={SX_SUBMENU}>
        <DesktopList items={left} sx={SX_ROUTE_LEFT} />
      </Box>
      <Box sx={SX_SUBMENU_RIGHT}>
        <DesktopList items={right} sx={SX_ROUTE_RIGHT} />
      </Box>
    </Box>
  );
};

export default DesktopMenu;
